import { render, staticRenderFns } from "./medicalInsuranceSettlementRecord.vue?vue&type=template&id=1fadb948"
import script from "./medicalInsuranceSettlementRecord.vue?vue&type=script&lang=js"
export * from "./medicalInsuranceSettlementRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports